import Http from "./http";

export const getAllUserListAPI = (data) => {
  return Http.post("admin/getAllUsersList",data);
};
